import { Badge } from "reactstrap";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import StatsFormatter from "@components/formatters/stats-formatter";
import { getStatusBadge } from "@src/utility/helpers/utils";

export const getColumns = () => {
    return [
        {
            name    : "Name",
            selector: (row) => row.name,
            width   : "300px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.name}
                    id={`name-${row._id}`}
                    max={35}/>
            )
        },
        {
            name: "Description",
            cell: (row) => <LongNameFormatter
                content={row.description}
                id={`desc-${row._id}`}
                max={35}/>
        },
        {
            name    : "Score",
            selector: (row) => row.score,
            width   : "200px",
            cell    : (row) => (
                <StatsFormatter
                    num={row.score}
                    className="text-primary cursor-pointer"/>
            )
        },
        {
            name    : "Impact",
            selector: (row) => row.impact,
            width   : "200px",
            cell    : (row) => {
                return (
                    <Badge color={getStatusBadge(row.impact).color}>
                        {getStatusBadge(row.impact).title}
                    </Badge>
                );
            }
        }
    ];
};
